import { render, staticRenderFns } from "./commonDecalDialog.vue?vue&type=template&id=646e8ab0&scoped=true&"
import script from "./commonDecalDialog.vue?vue&type=script&lang=js&"
export * from "./commonDecalDialog.vue?vue&type=script&lang=js&"
import style0 from "./commonDecalDialog.vue?vue&type=style&index=0&id=646e8ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e8ab0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VTextField})
